var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAprovacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.741,
    height: 21.702,
    viewBox: "0 0 22.741 21.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aprovar",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1656",
    "data-name": "Caminho 1656",
    d: "M10.8,21.688c-2.056,0-4.114.01-6.17,0a4.68,4.68,0,0,1-2.447-.551A4.079,4.079,0,0,1,.061,17.805C.023,17.334,0,16.858,0,16.383q0-5.875.01-11.75A4.571,4.571,0,0,1,.767,1.861a4.045,4.045,0,0,1,3.1-1.79C4.584.02,5.3.006,6.022,0q4.521-.011,9.04,0a1.074,1.074,0,0,1,1.165.935,1.071,1.071,0,0,1-.949,1.218c-.11.009-.22.007-.328.007q-4.79,0-9.573.007c-.382,0-.764.013-1.143.038a2.019,2.019,0,0,0-2.039,2.06c-.02.372-.036.745-.036,1.118q0,5.506,0,11.014c0,.464.032.932.08,1.395A1.892,1.892,0,0,0,3.868,19.44c.738.071,1.486.091,2.23.094q5.087.011,10.18,0c.372,0,.744-.014,1.116-.036a2.016,2.016,0,0,0,2.059-2.12c.032-.906.036-1.813.043-2.72,0-1.281-.006-2.561,0-3.842a1.054,1.054,0,0,1,.91-1.033,1.065,1.065,0,0,1,1.2.758,1.315,1.315,0,0,1,.046.376c0,2.052,0,4.1-.013,6.155a4.707,4.707,0,0,1-.583,2.493,4.04,4.04,0,0,1-3.277,2.066c-.757.056-1.522.064-2.283.068-1.566.009-3.131,0-4.7,0v-.013",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1657",
    "data-name": "Caminho 1657",
    d: "M8.815,11.216c.116-.143.172-.229.243-.3Q13.928,6.032,18.8,1.15A1.1,1.1,0,0,1,19.946.793a1.079,1.079,0,0,1,.537,1.735,2.516,2.516,0,0,1-.192.2q-5.285,5.3-10.571,10.59a1.111,1.111,0,0,1-1.8,0L4.833,10.226a1.053,1.053,0,0,1-.284-1.142,1.02,1.02,0,0,1,.916-.731,1.067,1.067,0,0,1,.913.35c.741.745,1.483,1.486,2.224,2.231a3.011,3.011,0,0,1,.213.281",
    transform: "translate(2.005 0.335)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAprovacao);
export default __webpack_public_path__ + "static/media/aprovacao.8b121161d01747c13fd2661587a20112.svg";
export { ForwardRef as ReactComponent };